export default {"src":"/_next/static/media/logo.646270dc.svg","height":39,"width":135};